
<div class="dialog-wrapper">
    <label>{{translate.instant('testId.TabSchedules.urlDialog.labelUrl')}}</label>
    <input class="form-control" type="text" value="{{testUrltoCopy}}" #userinput> <br>
    <div class="btn-wrapper">
        <button (click)="copyInputMessage(userinput)" mat-flat-button class="btn-primary">
            <span>{{translate.instant('testId.TabSchedules.urlDialog.btnUrl')}}</span> </button>
    </div>
</div>


